import AsyncSelect from "react-select/async";
import { useContext } from 'react';
import { AppContext } from "../context";
import client from "../apollo";
import { toast } from "react-toastify";
import { FETCH_CONTACTS } from "./gql";


const AsyncContactDropdown = (props) => {
  const { theme } = useContext(AppContext);
  const _filterCompanies = async (inputValue: string) => {
    try {
      const { data } = await client.query({
        query: FETCH_CONTACTS,
        variables: {
          limit: 20,
          page: 1,
          searchText: inputValue,
          statusSearch: null,
          companyId: props?.companyId || null,
        },
        fetchPolicy: "network-only",
      });
      let option =
        data && data.allContacts
          ? data?.allContacts?.contacts?.map((item) => ({
            value: item.id,
            label: `${props?.mergeCompany
              ? `${item?.fullName} (${item?.id})`
              : item.fullName
              }`,
          }))
          : [];
      return option;
    } catch (error) {
      toast.error("Error while loading contacts!");
    }
  };

  const promiseOptions = (inputValue: any): any =>
    new Promise((resolve) => {
      resolve(_filterCompanies(inputValue));
    });

  const customStyles = {
    control: (styles, provided) => ({
      ...styles,
      width: props.width,
      background: theme === "light" ? provided.background : "#282828",
      borderColor: theme === "light" ? "#ced4da" : "#282828",
      color: theme === "light" ? provided.background : "#d9d9d9",
      fontSize: 12,
      "&:hover": {
        borderColor: theme === "light" ? "#ced4da" : "#282828",
        color: theme === "light" ? provided.background : "#d9d9d9",
      },
    }),
    menu: (provided) => ({
      ...provided,
      background: theme === "light" ? provided.background : "#282828",
      zIndex: props?.zIndex || 999999,
      color: theme === "light" ? provided.background : "#d9d9d9",
      fontSize: 12,
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: 12,
      background: theme === "light" ? provided.background : "#363636",
      "&:hover": {
        background: theme === "light" ? provided.background : "#474444",
        color: theme === "light" ? provided.background : "#d9d9d9",
      },
    }),
    container: (provided, state) => ({
      ...provided,
      fontSize: 12,
    }),
  };

  return (
    <>
      <AsyncSelect
        key={new Date().getTime()}
        isClearable
        value={props?.value?.value ? props?.value : null}
        ref={props.ref}
        styles={{ ...customStyles }}
        defaultOptions
        onChange={(selected: any) => {
          if (props.onSelected) {
            props.onSelected(selected?.value);
          }
          if (selected) {
            props.onChange(selected);
          } else {
            props.onChange("");
          }
        }}
        loadOptions={promiseOptions}
        placeholder={props?.placeholder}
      />
    </>
  );
};

export default AsyncContactDropdown;
